import React, { useState, useEffect, useContext } from 'react';
import { Select } from 'antd';
import { Link, useNavigate, useLocation } from "react-router-dom"; // Import Link from react-router-dom
import '../../../assets/styles/mobile.css';
import '../../../assets/styles/stylesnew.css';
import '../../../assets/styles/TableResponce.css';
import 'select2/dist/css/select2.min.css';
import '../../../assets/styles/themify-icons.css';
import '../../../assets/styles/responsivenew.css';
import '../../../assets/styles/style.css';
import 'select2';
import $ from 'jquery';
import { getuserdata, updateseodata } from '../../../services/apiService';
import { OneKlicksFileSDK } from '../../../SDK/OneKlicksFileSDK';
import useHandleNavigation from '../../../Uitiles/handleNavigation';
import { useAuth } from '../../../context/AuthContext';
import { useCurrency } from '../../../context/CurrencyContext';
import logo from '../../../assets/images/logo.png';
import icon from '../../../assets/images/icon.png';
import userimglocal from '../../../assets/images/9334243.jpg';
import { oneKlicks } from '../../../SDK/oneclick';
import { getSettings } from '../../../services/settingsService';
import ImageShow from '../../../Uitiles/ImageShow';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import { loginapi } from "../../../services/apiService";
import doctor from '../../../assets/images/doctor-icon.png';
import doctorred from '../../../assets/images/doctor-icon-red.png';
import hospital from '../../../assets/images/hospital-icon.png';
import hospitalred from '../../../assets/images/hospital-icon-red.png';
import shop from '../../../assets/images/shop-icon.png';
import shopred from '../../../assets/images/shop-icon-red.png';
import diagnostic from '../../../assets/images/Diagnostic-icon.png';
import diagnosticred from '../../../assets/images/Diagnostic-icon-red.png';
import MobileMenu from './MobileMenu';
import useOs from '../../../hooks/Os';
import CssLinks from './CssLinks';




const Header = ({ setLoginbutton, isMobile, userType = "", showsiderbar = false }) => {
  console.log("setLoginbutton", setLoginbutton);
  const [isAtTop, setIsAtTop] = useState(true);  // State to track if we're at the top
  const [isLeftPopupOpen, setIsLeftPopupOpen] = useState(false);  // State for left popup
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigation = useHandleNavigation();
  const { selectedCurrency, currencies, updateCurrency, isLoading: currencyLoading } = useCurrency();

  const { isLoggedIn, userData, logout, login } = useAuth();
  const [userimg, setUserimg] = useState("");
  const [settings, setSettings] = useState({});
  const [seoData, setSeoData] = useState({});
  const [localuser, setLocaluser] = useState(null);

  // Get platform info using hook
  const platformInfo = useOs();
  console.log("Platform Info (JSON):", platformInfo);




  useEffect(() => {
    getseodata();
  }, [location.pathname]);

  const getlocaluser = async () => {
    const localuser = localStorage.getItem("presentuser");
    console.log("localuser getlocaluser function :", localuser);
    setLocaluser(localuser);
  }

  const getseodata = async () => {
    console.log("seodata getseodata : run", window.location.pathname);
    try {
      const tableSchema = "";
      const tableName = "seo_data";
      const pagePath = (window.location.pathname || "/").replace(/\/+$|^$/, "");
      const normalizedPath = pagePath === "" ? "/" : pagePath;
      const conditions = {
        page_path: normalizedPath
      };
      const orderBy = "id DESC";
      const search = "";
      const pagination = {};
      const margedata = [
        {
          target_table: "seo_data",
          target_column: "page_id",
          target_value: "id",
          target_label: "seo_data"
        }
      ];
      console.log("seodata getseodata conditions", conditions);
      let seodata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
      console.log("seodata getseodata :", seodata);

      if (seodata?.data?.length > 0) {
        console.log("seodata getseodata updated :", seodata.data[0]);
        setSeoData(seodata.data[0]);
        return;
      }

    } catch (error) {
      console.error("Error getting seo data", error);
    }
  }

  useEffect(() => {
    getSettings().then(settings => {
      setSettings(settings);
    });
    let href = "";

    if (seoData.twitter_image !== "") {
      href = seoData.twitter_image;
      console.log("href icon seoData.twitter_image :", href);
    } else if (seoData.og_image !== "") {
      href = seoData.og_image;
      console.log("href icon seoData.og_image :", href);
    } else if (settings.favicon_url !== "") {
      href = process.env.REACT_APP_API_BASE_LIVE_URL + '/' + settings.favicon_url;
      console.log("href icon settings.favicon_url :", href);
    } else {
      href = icon;
      console.log("href icon icon :", href);
    }

    if (!href) return;

    // Remove existing favicon links (including any from index.html)
    document
      .querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]')
      .forEach((el) => el.parentNode && el.parentNode.removeChild(el));

    // Add our favicon
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = href;
    // optional: set type if you know it’s png/ico
    link.type = href.endsWith('.ico') ? 'image/x-icon' : 'image/png';
    document.head.appendChild(link);
  }, [seoData]);


  const loginreturn = async () => {
    console.log('Attempting email login...');
    const localuser = localStorage.getItem("presentuser");
    const redirect_url = localStorage.getItem("redirect_url_admin");
    console.log("redirect_url loginreturn function :", redirect_url);
    console.log("localuser loginreturn function :", localuser);
    const parsedData = JSON.parse(localuser);
    console.log("parsedData loginreturn function :", parsedData);
    const loginResponse = await loginapi(parsedData.email, parsedData.pass, true);
    console.log('Login response:', loginResponse);

    const user = loginResponse.data[0];

    if (user) {
      if (user.status === "2") {
        toast.error("Your account has been deleted. Please contact support.");
        return;
      }

      const userData = {
        id: user.id,
        email: user.email,
        user_type: user.user_type || "user",
        display_name: user.display_name || user.email
      };

      console.log('User data prepared for login:', userData);
      // Use the login function from AuthContext
      const loginSuccess = await login(userData);
      console.log('Login success status:', loginSuccess);

      if (loginSuccess) {
        toast.success("Login successful!", { autoClose: 2000 });
        navigate(redirect_url);
      } else {
        console.error('Login failed - login function returned false');
        toast.error("Login failed. Please try again.");
      }
    } else {
      console.error('No user data in response');
      toast.error("Invalid credentials. Please try again.");
    }
  }


  useEffect(() => {
    // Function to check if we're at the top of the page
    getUserData();
    getlocaluser();
    getSettings().then(settings => {
      setSettings(settings);
    });
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsAtTop(true);  // If the scroll position is at the top, set state to true
      } else {
        setIsAtTop(false);  // If scrolled down, set state to false
      }
    };

    window.addEventListener('scroll', handleScroll);  // Add scroll event listener

    // Initialize select2 with custom template
    try {
      const $select = $('#currency-select');
      if ($select.length && !$select.hasClass('select2-hidden-accessible')) {
        $select.select2({
          allowClear: false,
          width: '90px',
          minimumResultsForSearch: Infinity,
          templateResult: formatCurrency,
          templateSelection: formatCurrency
        });
      }
    } catch (error) {
      console.warn('Error initializing select2:', error);
    }

    // Handle currency change
    $('#currency-select').on('change', async function (e) {
      const newCurrency = e.target.value;
      updateCurrency(newCurrency);

      if (isLoggedIn && userData && userData.id) {
        const tableSchema = "";
        const tableName = "users";
        const data = {
          currency: newCurrency
        }
        const condition = {
          id: userData.id
        }
        try {
          const updateCurrencyResult = await oneKlicks.update(tableSchema, tableName, data, condition);
          console.log('updateCurrency', updateCurrencyResult);
        } catch (err) {
          console.error('Currency update failed', err);
        }
      } else {
        console.log('User is not logged in');
      }
      // No reload
    });

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Cleanup select2 safely
      try {
        const $select = $('#currency-select');
        if ($select.length && $select.hasClass('select2-hidden-accessible')) {
          $select.select2('destroy');
        }
      } catch (error) {
        console.warn('Error destroying select2:', error);
      }
    };
  }, []);  // Empty array to only run on mount and unmount

  // Sync select2 value with selectedCurrency
  useEffect(() => {
    try {
      const $select = $('#currency-select');
      if ($select.length && $select.hasClass('select2-hidden-accessible')) {
        $select.val(selectedCurrency).trigger('change.select2');
      }
    } catch (error) {
      console.warn('Error syncing select2 value:', error);
    }
  }, [selectedCurrency]);

  // Custom format function for Select2
  const formatCurrency = (currency) => {
    if (!currency.id) return currency.text;
    const currencyData = currencies.find(c => c.code === currency.id);
    if (!currencyData) return currency.text;

    return $(
      `<div class="currency-option" style="font-size: 14px; padding: 2px 0;">
        <span class="currency-code">${currencyData.code}</span>
      </div>`
    );
  };

  const handleLoginButton = () => {
    console.log("handleLoginButton run");
    setLoginbutton(true);
  };

  const getUserData = async () => {
    const userData = await getuserdata("full");
    if (userData?.profile_photo_url) {
      setUserimg(userData.profile_photo_url);
    }
    if (userData?.currency) {
      updateCurrency(userData.currency);
    }
  }

  const handleDashboardClick = (e) => {
    e.preventDefault();
    const userData = localStorage.getItem('userData');
    handleNavigation(JSON.parse(userData));
  };

  const handleCurrencyChange = async (value) => {
    updateCurrency(value);
    // save the currency to the local storage
    // incase user is logged in, save the currency to the database
    if (isLoggedIn && userData && userData.id) {
      const tableSchema = "";
      const tableName = "users";
      const data = {
        currency: value
      }
      const condition = {
        id: userData.id
      }
      const updateCurrencyResult = await oneKlicks.update(tableSchema, tableName, data, condition);
      console.log('updateCurrency', updateCurrencyResult);
    }
    localStorage.setItem('selectedCurrency', value);
  }

  useEffect(() => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    if (selectedCurrency) {
      updateCurrency(selectedCurrency);
    }
  }, []);

  return (
    <>
      <Helmet>
        {/* Title & Favicon */}
        <title>{seoData.title || "MeddyList – Book Doctor Appointments Online"}</title>
        <link rel="icon" href={seoData.twitter_image || icon} type="image/x-icon" />

        {/* Standard Meta */}
        <meta name="description" content={seoData.description || "MeddyList is your one-stop healthcare booking solution. Book doctors, hospitals, and clinics easily with real-time availability."} />
        <meta name="keywords" content={seoData.keywords || "meddylist, doctor booking, hospital management, healthcare software, patient appointment, medical directory"} />
        <meta name="author" content={seoData.author || "MeddyList Team"} />

        {/* Canonical */}
        <link rel="canonical" href={seoData.og_url || (typeof window !== 'undefined' ? window.location.href : 'https://tech2day.co.in')} />

        {/* Open Graph (Facebook, LinkedIn Preview) */}
        <meta property="og:title" content={seoData.og_title || "MeddyList – Book Doctor Appointments Online"} />
        <meta property="og:description" content={seoData.og_description || "Find and book doctors and hospitals quickly using MeddyList. Trusted by healthcare providers."} />
        <meta property="og:image" content={seoData.og_image || "//css.meddylist.com//assets/og-banner.png"} />
        <meta property="og:url" content={seoData.og_url || (typeof window !== 'undefined' ? window.location.href : "https://tech2day.co.in")} />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.twitter_title || "MeddyList – Doctor Appointment Booking App"} />
        <meta name="twitter:description" content={seoData.twitter_description || "Discover top doctors and hospitals. Schedule appointments instantly with MeddyList."} />
        <meta name="twitter:image" content={seoData.twitter_image || "//css.meddylist.com//assets/og-banner.png"} />
        <meta name="twitter:url" content={seoData.og_url || (typeof window !== 'undefined' ? window.location.href : "https://tech2day.co.in")} />

      </Helmet>

      {/* SEO H1 Heading */}
      <h1 style={{
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden'
      }}>
        {seoData.title || seoData?.title || "MeddyList – Book Doctor Appointments Online"}
      </h1>

      <header id="dc-header" className="dc-header dc-haslayout">
        {userType === "" && (
          <div className="dc-topbar">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="dc-helpnum">
                    <span>Emergency Help!</span>
                    <a href={`tel:${settings.emergency_help_number}`}>{settings.emergency_help_number}</a>
                  </div>
                  <div className="dc-rightarea">
                    <ul className="dc-simplesocialicons dc-socialiconsborder">
                      {/* <li className="dc-facebook">
                        <a href="#">
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li className="dc-twitter">
                        <a href="#">
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li className="dc-linkedin">
                        <a href="#">
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li className="dc-googleplus">
                        <a href="#">
                          <i className="fab fa-google-plus-g"></i>
                        </a>
                      </li>
                      <li className="dc-youtube">
                        <a href="#">
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li> */}
                      <li className="" style={{ marginLeft: '5px' }}>
                        <Select value={selectedCurrency} onChange={handleCurrencyChange}>
                          {currencies.map((currency) => (
                            <Select.Option key={currency.code} value={currency.code}>
                              {currency.code}
                            </Select.Option>
                          ))}
                        </Select>

                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>)}
        {platformInfo?.os === "android" || platformInfo?.os === "ios" ? (
          <>
            <div className={`mobile-menu dc-navigationarea ${isAtTop ? '' : 'stickymain'} ${userType === "" ? "" : "admin-header"}`} style={{ width: userType === "" ? "" : "-webkit-fill-available" }} >
              <div className="mobile-menu-container">
                <div className="mobile-menu-content">
                  <div className="mobile-menu-header">
                    <div className="mobile-menu-header-left">
                      <div className="mobile-menu-header-left-logo">
                        <Link to="/">
                          <ImageShow url={settings.logo_url} key={settings.site_logo} height={30} width={120} style={{ borderRadius: '5px' }} />
                        </Link>
                      </div>
                    </div>
                    <div className="mobile-menu-header-right">
                      <div className="mobile-header-icons">
                        {/* Search Icon */}
                        <button className="mobile-header-icon-btn" onClick={() => {/* Add search functionality */ }}>
                          <i className="ti-search"></i>
                        </button>

                        {/* Notification Icon */}
                        <button className="mobile-header-icon-btn" onClick={() => {/* Add notification functionality */ }}>
                          <i className="ti-bell"></i>
                          <span className="notification-badge">0</span>
                        </button>

                        {/* User Icon */}
                        {isLoggedIn ? (
                          <div className="mobile-user-dropdown">
                            <button className="mobile-header-icon-btn user-icon" onClick={() => {/* Add user menu functionality */ }}>
                              <img
                                src={userimg === "" ? userimglocal : process.env.REACT_APP_API_BASE_URL + userimg}
                                alt="User"
                                style={{
                                  width: '30px',
                                  height: '30px',
                                  borderRadius: '50%',
                                  objectFit: 'cover'
                                }}
                              />
                            </button>
                          </div>
                        ) : (
                          <Link to="/mobile/login" className="mobile-header-icon-btn">
                            <i className="ti-user"></i>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <><div className={`dc-navigationarea ${isAtTop ? '' : 'stickymain'} ${userType === "" ? "" : "admin-header"}`} style={{ left: userType === "" ? "" : (window.innerWidth < 700 ? "0px" : (isAtTop ? "0px" : showsiderbar == true ? "50px" : "250px")), width: userType === "" ? "" : "-webkit-fill-available" }}>
            <div className={`${userType === "" ? "container " : "container "}`} style={{ maxWidth: userType === "" ? "" : "none" }}>
              <div className="row">
                <div className="col-12">
                  <div className="hidpi-logowrap">
                    <div className="hidpi-logowrap">
                      <nav id="dc-nav" className="dc-nav navbar-expand-lg">
                        <button
                          className="navbar-toggler"
                          type="button"
                          data-toggle="collapse"
                          aria-controls="navbarNav"
                          onClick={() => setIsLeftPopupOpen(true)}
                          aria-expanded="false"
                          aria-label="Toggle navigation"
                        >
                          <i className="lnr lnr-menu"></i>
                        </button>
                      </nav>
                      <strong className="dc-logo">
                        {isMobile == true ? (
                          <Link to="/">
                            {settings.site_logo_url ? (
                              <ImageShow url={settings.site_logo_url} key={settings.site_logo} height={0} width={120} />
                            ) : (
                              <img src={icon} alt="MeddyList" style={{ width: '42px' }} />
                            )}
                          </Link>
                        ) : (
                          <Link to="/">
                            {settings.site_logo_url ? (
                              <ImageShow url={settings.site_logo_url} key={settings.site_logo} height={0} width={0} />
                            ) : (
                              <img src={logo} alt="MeddyList" />
                            )}
                          </Link>
                        )}
                      </strong>
                    </div>

                    <div className="dc-rightarea">
                      <nav id="dc-nav" className="dc-nav navbar-expand-lg">

                        <div
                          className="collapse navbar-collapse dc-navigation"
                          id="navbarNav"
                        >
                          <ul id="menu-header-menu" className="navbar-nav">
                            <li className="menu-item menu-item-type-custom menu-item-object-custom">
                              <Link to="/" data-slug="main" className="ajax-link">
                                Home
                              </Link>
                              {window.location.pathname === "/" && (
                                <div className='show-on-hover'>
                                </div>
                              )}
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page">
                              <Link
                                to="/search-doctors"
                                className="ajax-link"
                                data-slug="search-doctors"
                              >
                                Doctors
                              </Link>
                              {window.location.pathname === "/search-doctors" && (
                                <div className='show-on-hover'>
                                </div>
                              )}
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page">
                              <Link
                                to="/search-hospitals"
                                className="ajax-link"
                                data-slug="search-hospitals"
                              >
                                Hospitals
                              </Link>
                              {window.location.pathname === "/search-hospitals" && (
                                <div className='show-on-hover'>
                                </div>
                              )}
                            </li>
                            <li className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children dropdown">
                              <span className="dc-dropdowarrow">
                                <i className="lnr lnr-chevron-right"></i>
                              </span>
                              <Link to="#" className="ajax-link" data-slug="pharmacy-store">
                                Pharmacy
                              </Link>
                              {window.location.pathname === "/pharmacylist" && (
                                <div className='show-on-hover'>
                                </div>
                              )}
                              <ul className="sub-menu">
                                <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                  <Link to="/pharmacylist">
                                    Pharmacy List
                                  </Link>
                                </li>
                                {/* <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                  <Link to="/shop">
                                    Shop
                                  </Link>
                                </li> */}
                              </ul>
                            </li>
                            {/* <li className="menu-item menu-item-type-custom menu-item-object-custom">
                              <Link to="#" className={window.location.pathname === "/search-diagnostic" ? "active" : "ajax-link"} data-slug="labs-digonies">
                                Diagnostic
                              </Link>
                            </li> */}
                            {isMobile == true && (
                              <>
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                  <Link to="/login" className="ajax-link" data-slug="labs-digonies">
                                    Login
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-custom menu-item-object-custom">
                                  <Link to="/authentication" className="ajax-link" data-slug="labs-digonies">
                                    Join Now
                                  </Link>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      </nav>

                      {isLoggedIn ? (
                        <>
                          <ul className="add-nav shop-nav">
                            <ul className="add-nav shop-nav">
                              <li className="cart-area">
                                <div className="dc-cart dropdown">
                                  <a href="javascript:;" id="dc-cart" className="cart-contents">
                                    <i className="fa fa-cart-plus"></i>
                                    <span className="dc-badge">0</span>
                                  </a>

                                  <div className="dropdown-menu dc-mini-cart" aria-labelledby="dc-cart">
                                    <div className="widget_shopping_cart_content">
                                      <p className="woocommerce-mini-cart__empty-message">
                                        No products in the cart.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul></ul>
                        </>
                      ) : (
                        <>
                        </>
                      )}



                      {isLoggedIn ? (
                        <>
                          <div className="dc-userlogin dc-userlogedin sp-top-menu">
                            <figure className="dc-userimg">
                              <img src={userimg === "" ? userimglocal : process.env.REACT_APP_API_BASE_URL + userimg} width="40" height="40" style={{ borderRadius: '50%', height: '50px', width: '50px', maxWidth: '45px', maxHeight: '50px' }} />
                            </figure>
                            {window.innerWidth > 576 && (
                              <div className="dc-username header-username">
                                <h4 className="header-username-text">{userData?.display_name || userData?.email}</h4>
                              </div>
                            )}
                            {userType === "admin" || userType === "staff" ? (
                              <>
                                <nav className="dc-usernav">
                                  <ul className="dashboard-menu-top">
                                    <li className="dc-active">
                                      <a href="//css.meddylist.com//dashboard/?ref=insights&amp;identity=61">
                                        <i className="ti-desktop"></i>
                                        <span>Dashboard</span>
                                      </a>
                                    </li>
                                    <li>
                                      <a target="_blank" href="//css.meddylist.com//?post_type=doctors&amp;p=1719">
                                        <i className="ti-eye"></i>
                                        <span>View My Profile</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=chat&amp;identity=61">
                                        <i className="ti-email"></i>
                                        <span>Inbox</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=profile&amp;mode=settings&amp;identity=61">
                                        <i className="ti-settings"></i>
                                        <span>Profile Settings</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=specialities&amp;mode=settings&amp;identity=61">
                                        <i className="ti-notepad"></i>
                                        <span>Specialities &amp; Services</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=account-settings&amp;mode=manage&amp;identity=61">
                                        <i className="ti-panel"></i>
                                        <span>Account Settings</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=appointment&amp;mode=listing&amp;identity=61">
                                        <i className="lnr lnr-clock"></i>
                                        <span>Appointment List</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=appointment&amp;mode=setting&amp;identity=61">
                                        <i className="ti-clipboard"></i>
                                        <span>Appointment Settings</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=manage-article&amp;mode=listings&amp;identity=61">
                                        <i className="ti-pencil-alt"></i>
                                        <span>Manage article</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=payouts&amp;mode=settings&amp;identity=61">
                                        <i className="ti-credit-card"></i>
                                        <span>Payouts Settings</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=saved&amp;identity=61">
                                        <i className="ti-heart"></i>
                                        <span>My Saved Items</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=package&amp;identity=61">
                                        <i className="ti-package"></i>
                                        <span>Packages</span>
                                      </a>
                                    </li>
                                    <li className="">
                                      <a href="//css.meddylist.com//dashboard/?ref=invoices&amp;identity=61">
                                        <i className="ti-file"></i>
                                        <span>Invoices</span>
                                      </a>
                                    </li>
                                    <li><a onClick={() => {
                                      try {
                                        // Use the proper logout function from AuthContext
                                        logout();
                                      } catch (error) {
                                        console.error("Error during logout:", error);
                                        // Fallback to manual logout
                                        localStorage.clear();
                                        sessionStorage.clear();
                                        navigate("/", { replace: true });
                                        window.location.reload();
                                      }
                                    }}><i className="ti-shift-right"></i> <span>Logout</span></a></li>
                                  </ul>
                                </nav>
                              </>
                            ) : (
                              <>
                                <nav className="dc-usernav">
                                  <ul className="dashboard-menu-top">
                                    {localuser && (
                                      <li className="dc-active">
                                        <a href="#" onClick={loginreturn}>
                                          <i className="ti-desktop"></i>
                                          <span>Return to Dashboard</span>
                                        </a>
                                      </li>
                                    )}
                                    <li className="dc-active">
                                      <a href="javascript:void(0);" onClick={handleDashboardClick}>
                                        <i className="ti-desktop"></i>
                                        <span>Dashboard</span>
                                      </a>
                                    </li>
                                    <li>
                                      <Link to="/user-dashboard?tab=appointments">
                                        <i className="ti-calendar"></i>
                                        <span>My Appointments</span>
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to="/user-dashboard?tab=profile">
                                        <i className="ti-user"></i>
                                        <span>Profile Settings</span>
                                      </Link>
                                    </li>
                                    <li>
                                      <a href="javascript:void(0);" onClick={logout}>
                                        <i className="ti-power-off"></i>
                                        <span>Logout</span>
                                      </a>
                                    </li>
                                  </ul>
                                </nav>
                              </>
                            )}

                          </div>
                        </>

                      ) : (
                        <div className="dc-loginarea">
                          <figure className="dc-userimg">
                            <img
                              src="//css.meddylist.com//wp-content/themes/doctreat/images/user.png"
                              alt="user"
                              onClick={handleLoginButton}
                            />
                          </figure>
                          {isMobile !== true && (
                            <>
                              <div className="dc-loginoption">
                                <a href="javascript:void(0);" className="dc-loginbtn" onClick={handleLoginButton}>
                                  Login
                                </a>
                              </div>
                              <Link to="/authentication" className="dc-btn">
                                Join Now
                              </Link>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>
        )}

      </header>

      {/* Left Side Popup */}
      <div className={`dc-left-popup ${isLeftPopupOpen ? 'open' : ''}`}>
        <div className="dc-left-popup-overlay" onClick={() => setIsLeftPopupOpen(false)}></div>
        <MobileMenu isLeftPopupOpen={isLeftPopupOpen} setIsLeftPopupOpen={setIsLeftPopupOpen} isLoggedIn={isLoggedIn} userData={userData} userimg={userimg} settings={settings} userType={userType} />
      </div>


      {platformInfo?.os === "android" || platformInfo?.os === "ios" ? (
        <>
          <div className="mobile-bottom-footer dc-footbar-fixed">
            <div className="mobile-bottom-footer container">
              <div className="mobile-bottom-footer d-flex justify-content-between" style={{ alignItems: 'center', height: '55px' }}>
                <Link to="/search-doctors" className="mobile-bottom-footer dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/search-doctors" ? "var(--themecolor)" : "var(--themecolor)" }}>
                  <img src={window.location.pathname === "/search-doctors" ? doctor : doctor} alt="doctor" style={{ width: '25px', height: '25px', filter: `grayscale(${window.location.pathname === "/search-doctors" ? "0" : "1"})` }} />
                  {window.location.pathname === "/search-doctors" ? "Doctors" : ""}
                </Link>
                <Link to="/search-hospitals" className="mobile-bottom-footer dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/search-hospitals" ? "var(--themecolor)" : "var(--themecolor)" }}>
                  <img src={window.location.pathname === "/search-hospitals" ? hospital : hospital} alt="hospital" style={{ width: '25px', height: '25px', filter: `grayscale(${window.location.pathname === "/search-hospitals" ? "0" : "1"})` }} />
                  {window.location.pathname === "/search-hospitals" ? "Hospitals" : ""}
                </Link>
                <Link to="/mobile/home" className="mobile-bottom-footer dc-footbar-fixed-menu-item home" style={{ backgroundColor: window.location.pathname === "/mobile/home" ? "var(--themecolor)" : "var(--themecolor)" }}>
                  <i className="ti-home" style={{ fontSize: '25px', color: "#ffff" }}></i>
                </Link>
                <Link to="/shop" className="mobile-bottom-footer dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/shop" ? "var(--themecolor)" : "var(--themecolor)" }}>
                  <img src={window.location.pathname === "/shop" ? shop : shop} alt="shop" style={{ width: '25px', height: '25px', filter: `grayscale(${window.location.pathname === "/shop" ? "0" : "1"})` }} />
                  {window.location.pathname === "/shop" ? "Shop" : ""}
                </Link>
                <Link to="/diagnostic" className="mobile-bottom-footer dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/" ? "var(--themecolor)" : "var(--themecolor)" }}>
                  <img src={window.location.pathname === "/diagnostic" ? diagnostic : diagnostic} alt="diagnostic" style={{ width: '25px', height: '25px', filter: `grayscale(${window.location.pathname === "/diagnostic" ? "0" : "1"})` }} />
                  {window.location.pathname === "/diagnostic" ? "Diagnostic" : ""}
                </Link>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="dc-footbar-fixed">
          <div className="container">
            <div className="d-flex justify-content-between" style={{ alignItems: 'center', height: '55px' }}>
              <Link to="/search-doctors" className="dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/search-doctors" ? "var(--secthemecolor)" : "var(--themecolor)" }}>
                <img src={window.location.pathname === "/search-doctors" ? doctorred : doctor} alt="doctor" style={{ width: '25px', height: '25px', color: window.location.pathname === "/search-doctors" ? "var(--secthemecolor)" : "var(--themecolor)" }} />
                {window.location.pathname === "/search-doctors" ? "Doctors" : ""}
              </Link>
              <Link to="/search-hospitals" className="dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/search-hospitals" ? "var(--secthemecolor)" : "var(--themecolor)" }}>
                <img src={window.location.pathname === "/search-hospitals" ? hospitalred : hospital} alt="hospital" style={{ width: '25px', height: '25px', color: window.location.pathname === "/search-hospitals" ? "var(--secthemecolor)" : "var(--themecolor)" }} />
                {window.location.pathname === "/search-hospitals" ? "Hospitals" : ""}
              </Link>
              <Link to="/" className="dc-footbar-fixed-menu-item home" style={{ backgroundColor: window.location.pathname === "/" ? "var(--secthemecolor)" : "var(--themecolor)" }}>
                <i className="ti-home" style={{ fontSize: '25px', color: "#ffff" }}></i>
              </Link>
              <Link to="/shop" className="dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/shop" ? "var(--secthemecolor)" : "var(--themecolor)" }}>
                <img src={window.location.pathname === "/shop" ? shopred : shop} alt="shop" style={{ width: '25px', height: '25px', color: window.location.pathname === "/shop" ? "var(--secthemecolor)" : "var(--themecolor)" }} />
                {window.location.pathname === "/shop" ? "Shop" : ""}
              </Link>
              <Link to="/diagnostic" className="dc-footbar-fixed-menu-item" style={{ color: window.location.pathname === "/" ? "var(--secthemecolor)" : "var(--themecolor)" }}>
                <img src={window.location.pathname === "/diagnostic" ? diagnosticred : diagnostic} alt="diagnostic" style={{ width: '25px', height: '25px', color: window.location.pathname === "/diagnostic" ? "var(--secthemecolor)" : "var(--themecolor)" }} />
                {window.location.pathname === "/diagnostic" ? "Diagnostic" : ""}
              </Link>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default Header;
